/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'user-info': {
    width: 266.602,
    height: 200,
    viewBox: '0 0 1365 1024',
    data: '<defs/><path pid="0" d="M777.273 179.143h409.259V265.5h-409.26v-86.357zm0 186.197h409.259v86.358h-409.26V365.34zm107.406 198.258h301.853v86.358H884.679v-86.358zm-25.543 425.017c0-194.446-133.689-357.433-313.116-403.968a288.882 288.882 0 00184.718-269.596 289.735 289.735 0 00-289.11-289.11 289.735 289.735 0 00-289.166 289.11c0 122.425 76.573 227.555 184.718 269.596C157.696 631.182 24.064 794.17 24.064 988.615v8.306h86.357v-6.827c0-183.182 147.911-331.093 331.094-331.093 183.296 0 331.207 147.911 331.207 331.093v6.827h86.357v-8.306zM240.356 315.79a201.273 201.273 0 11201.272 201.33 201.728 201.728 0 01-201.272-201.387z"/><path pid="1" d="M1263.16 18.432H691.656v86.357h530.205a30.151 30.151 0 0130.037 30.038v745.7a30.151 30.151 0 01-30.037 30.037h-218.568v86.357h259.869c41.301 0 75.093-33.792 75.093-75.093V93.525c0-41.301-33.792-75.093-75.093-75.093z"/>'
  }
})
